import { Routes, Route } from "react-router-dom";

/* NORMAL PAGES */
import Home from "../pages/Home";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import Register from "../pages/Register";

import About from "../pages/policies/About";
import Privacy from "../pages/policies/Privacy";
import Terms from "../pages/policies/Terms";
import Disclaimer from "../pages/policies/Disclaimer";

import DemoContent from "../pages/demo/DemoContent";
import DemoDashboard from "../pages/DemoDashboard";

import Subscription from "../pages/Subscription";
import Features from "../pages/Features";

/* ✅ PROTECTION */
import PremiumRoute from "./PremiumRoute";
import PremiumDashboard from "../pages/PremiumDashboard";





import UpscAnalysis from "../pages/premium/UpscAnalysis";
import Prelims from "../pages/premium/Prelims";
import Mains from "../pages/premium/Mains";
import Interview from "../pages/premium/Interview";
import Subjects from "../pages/premium/Subjects";




import Polity from "../pages/premium/prelims/Polity";
import Geography from "../pages/premium/prelims/Geography";
import Economy from "../pages/premium/prelims/Economy";
import Environment from "../pages/premium/prelims/Environment";
import Science from "../pages/premium/prelims/Science";
import CurrentAffairs from "../pages/premium/prelims/CurrentAffairs";
import Reading from "../pages/premium/prelims/Reading";
import Reasoning from "../pages/premium/prelims/Reasoning";
import Analytical from "../pages/premium/prelims/Analytical";
import Numeracy from "../pages/premium/prelims/Numeracy";




export default function AppRoutes() {
  return (
    <Routes>

      {/* 🌐 PUBLIC ROUTES */}
      <Route path="/" element={<Home />} />
      <Route path="/features" element={<Features />} />

      {/* 👤 AUTH ROUTES */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* 📊 NORMAL USER ROUTES */}
      <Route path="/dashboard" element={<Dashboard />} />

      {/* 🧪 DEMO ROUTES */}
      <Route path="/demo" element={<DemoDashboard />} />
      <Route path="/demo/:category" element={<DemoContent />} />

      {/* 📄 POLICY PAGES */}
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/disclaimer" element={<Disclaimer />} />

      {/* 💳 SUBSCRIPTION */}
      <Route path="/subscription" element={<Subscription />} />

      {/* 🔐 PREMIUM PROTECTED */}
      <Route
        path="/premium-current-affairs"
        element={
          <PremiumRoute>
            <PremiumDashboard />
          </PremiumRoute>
        }
      />




{/* ✅ ADD ALL NEW ROUTES HERE */}

<Route path="/upsc-analysis" element={<PremiumRoute><UpscAnalysis /></PremiumRoute>} />
<Route path="/prelims" element={<PremiumRoute><Prelims /></PremiumRoute>} />
<Route path="/mains" element={<PremiumRoute><Mains /></PremiumRoute>} />
<Route path="/interview" element={<PremiumRoute><Interview /></PremiumRoute>} />
<Route path="/subjects" element={<PremiumRoute><Subjects /></PremiumRoute>} />



/* PRELIMS SUB PAGES */




<Route path="/prelims-polity" element={<PremiumRoute><Polity /></PremiumRoute>} />
<Route path="/prelims-geography" element={<PremiumRoute><Geography /></PremiumRoute>} />
<Route path="/prelims-economy" element={<PremiumRoute><Economy /></PremiumRoute>} />
<Route path="/prelims-environment" element={<PremiumRoute><Environment /></PremiumRoute>} />
<Route path="/prelims-science" element={<PremiumRoute><Science /></PremiumRoute>} />
<Route path="/prelims-current-affairs" element={<PremiumRoute><CurrentAffairs /></PremiumRoute>} />

/* CSAT */

<Route path="/csat-reading" element={<PremiumRoute><Reading /></PremiumRoute>} />
<Route path="/csat-reasoning" element={<PremiumRoute><Reasoning /></PremiumRoute>} />
<Route path="/csat-analytical" element={<PremiumRoute><Analytical /></PremiumRoute>} />
<Route path="/csat-numeracy" element={<PremiumRoute><Numeracy /></PremiumRoute>} />





      {/* ❌ FALLBACK (VERY IMPORTANT) */}
      <Route
        path="*"
        element={
          <div className="text-center mt-5">
            <h2>404 - Page Not Found</h2>
          </div>
        }
      />

    </Routes>
  );
}